import React from 'react';
import './NotificationModal.css';

const NotificationModal = ({ 
  isOpen, 
  onClose, 
  type = 'success',
  title,
  message,
  confirmText = 'Aceptar',
  onConfirm,
  showCancel = false,
  cancelText = 'Cancelar'
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const icons = {
    success: '✓',
    error: '✗',
    warning: '⚠',
    info: 'ℹ'
  };

  return (
    <div className="notification-overlay" onClick={onClose}>
      <div className="notification-modal" onClick={(e) => e.stopPropagation()}>
        <div className={`notification-icon ${type}`}>
          {icons[type]}
        </div>
        
        {title && (
          <h3 className="notification-title">{title}</h3>
        )}
        
        {message && (
          <p className="notification-message">{message}</p>
        )}
        
        <div className="notification-footer">
          {showCancel && (
            <button 
              className="notification-cancel" 
              onClick={onClose}
            >
              {cancelText}
            </button>
          )}
          <button 
            className={`notification-confirm ${type}`} 
            onClick={handleConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
